import { render, staticRenderFns } from "./DocumentationContentSection.vue?vue&type=template&id=12535038&scoped=true&"
import script from "./DocumentationContentSection.vue?vue&type=script&lang=js&"
export * from "./DocumentationContentSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12535038",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
